import hit_1 from "../../assets/audio/hit1.wav";
import hit_2 from "../../assets/audio/hit2.wav";
import shoot from "../../assets/audio/shoot1.wav";

export const audio = {
  shoot1: new Audio(shoot),
  hit1: new Audio(hit_1),
  hit2: new Audio(hit_2),
};
